// frontend/src/components/OfflineBanner.jsx
//
// Bandeau persistant en haut de page quand le browser passe offline.
// Texte bilingue. Rendu conditionnel : null quand online → zéro impact
// DOM. Inline styles parce que c'est un overlay isolé qui n'a pas besoin
// d'entrer dans le design-system CSS.

import React, { useContext } from 'react';
import { LangContext } from '../App';
import { useOfflineBanner } from '../lib/pwa';

const T = {
  fr: {
    title: 'Vous êtes hors ligne',
    body: 'Les pages déjà visitées restent accessibles. La création / soumission est désactivée jusqu’au retour de la connexion.',
  },
  en: {
    title: "You're offline",
    body: 'Already-visited pages remain accessible. Creating or submitting is disabled until you reconnect.',
  },
};

export default function OfflineBanner() {
  const { lang } = useContext(LangContext);
  const t = T[lang] || T.fr;
  const isOffline = useOfflineBanner();
  if (!isOffline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'linear-gradient(90deg, #ad4d2b 0%, #c9a227 100%)',
        color: '#0c1f0c',
        padding: '0.6rem 1rem',
        fontSize: '0.86rem',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
        fontWeight: 500,
      }}
    >
      <strong>📡 {t.title}.</strong> {t.body}
    </div>
  );
}
